import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { GlobalProvider } from "./context/GlobalContext";
import { AudioProvider } from "./context/AudioContext";
// Initialize global media manager early
import "./utils/mediaManager";
import { initAmplitude } from "./config/amplitude";

// Boot Amplitude analytics
initAmplitude();
import RouteGuard from "./utils/RouteGuard.jsx";
import AppLayout from "./layouts/AppLayout.jsx";
import {
  Home,
  Degree,
  Degrees,
  Lesson,
  MusicPlayer,
  Login,
  Help,
  HelpArticle,
  Privacy,
  Welcome,
  NotFound,
  Forbidden,
  Unauthorized,
  Explore,
  Community,
  Post,
  Journal,
} from "./pages";
import "./index.css";
import "./basic-light.css";
import "./basic-dark.css";

const router = createBrowserRouter([
  {
    path: "/api/login",
    element: <Login />,
  },
  {
    element: (
      <RouteGuard>
        <AppLayout />
      </RouteGuard>
    ),
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "music-player",
        element: <MusicPlayer />,
      },
      {
        path: "degrees",
        element: <Degrees />,
      },
      {
        path: "degree/:degreeSlug",
        element: <Degree />,
      },
      {
        path: "lessons/:lessonId",
        element: <Lesson />,
      },
      {
        path: "journal",
        element: <Journal />,
      },
      {
        path: "explore",
        element: <Explore />,
      },
      {
        path: "help",
        element: <Help />,
      },
      {
        path: "help/:topicSlug",
        element: <HelpArticle />,
      },
      {
        path: "privacy",
        element: <Privacy />,
      },
      {
        path: "welcome",
        element: <Welcome />,
      },
      {
        path: "forbidden",
        element: <Forbidden />,
      },
      {
        path: "unauthorized",
        element: <Unauthorized />,
      },
      {
        path: "community",
        element: <Community />,
      },
      {
        path: "post/:postId",
        element: <Post />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <GlobalProvider>
      <AudioProvider>
        <RouterProvider router={router} />
      </AudioProvider>
    </GlobalProvider>
  </StrictMode>
);
